// extracted by mini-css-extract-plugin
export default {"P":"statis_P__FvnYO","H3":"statis_H3__bD2KT","UL":"statis_UL__N0DE0","center":"statis_center__jPvDs"};